import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

export const SwiperStyled = styled(Swiper)`
  width: 100%;
`;

export const SwiperSlideStyled = styled(SwiperSlide)`
  width: max-content;
`;
